module.exports = __webpack_public_path__ + "static/assets/42157e6edddc19588c3c2ff188703799.svg";